var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 4.9987C18.3332 4.08203 17.5832 3.33203 16.6665 3.33203H3.33317C2.4165 3.33203 1.6665 4.08203 1.6665 4.9987M18.3332 4.9987V14.9987C18.3332 15.9154 17.5832 16.6654 16.6665 16.6654H3.33317C2.4165 16.6654 1.6665 15.9154 1.6665 14.9987V4.9987M18.3332 4.9987L9.99984 10.832L1.6665 4.9987",
    stroke: "#207C97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.fd2a3147dd79c223985d012c6662d963.svg";
export { ForwardRef as ReactComponent };